<template>
  <v-card elevation="0" outlined>
    <div class="wrapper py-5 px-6">
      <div v-if="$vuetify.breakpoint.mdAndUp" class="d-flex align-center">
        <UserAvatarPicker :user="student" type="student" />
      </div>
      <div class="main-infor">
        <div class="w-100 d-flex flex-wrap align-center">
          <div class="mr-5 student-name-wrapper">
            <p class="text-h5 primary--text mb-0">{{ student.name }}</p>
            <p class="text-subtitle-2">{{ student.code | getStudentCode }}</p>
          </div>
          <div>
            <v-chip small class="white--text mb-4" :color="getColor(student.status)" label>
              {{ student.status | status }}
            </v-chip>
          </div>
        </div>
        <v-row>
          <v-col cols="12" md="2" class="py-2 d-flex flex-column justify-end">
            <p class="text-caption mb-0">Ngày sinh</p>
            <p class="text-subtitle-2 mb-0">
              {{ student.dob | ddmmyyyy }}
            </p>
          </v-col>
          <v-col cols="12" md="2" class="py-2 d-flex flex-column justify-end">
            <p class="text-caption mb-0">Lớp</p>
            <router-link
              style="text-decoration: none"
              :to="'/class/' + (student.currentClass && student.currentClass.id)"
            >
              <span v-if="student.currentClass">{{ student.currentClass && student.currentClass.title }}</span>
            </router-link>
          </v-col>
          <v-col cols="12" md="4" class="py-2 d-flex flex-column justify-end">
            <p class="text-caption mb-0">Bố / Người giám hộ</p>
            <p class="text-subtitle-2 mb-0">
              {{ this.student | _get('data.dadName') }} / {{ this.student | _get('data.dadPhone') }}
            </p>
          </v-col>
          <v-col cols="12" md="4" class="py-2 d-flex flex-column justify-end">
            <p class="text-caption mb-0">Mẹ / Người giám hộ</p>
            <p class="text-subtitle-2 mb-0">
              {{ this.student | _get('data.momName') }} / {{ this.student | _get('data.momPhone') }}
            </p>
          </v-col>
        </v-row>
      </div>
      <div class="detail-button">
        <v-btn @click="detailState = !detailState" small color="primary" outlined>Hồ sơ chi tiết</v-btn>
      </div>
    </div>
    <StudentProfileDetailDialog @edit="editState = !editState" :student="student" :state="detailState" />
    <EditStudentDialog :student="student" :state="editState" />
  </v-card>
</template>

<script>
import UserAvatarPicker from '@/components/basic/picker/UserAvatarPicker'
import StudentProfileDetailDialog from './StudentProfileDetailDialog'
import EditStudentDialog from './EditStudentDialog'

export default {
  components: {
    StudentProfileDetailDialog,
    EditStudentDialog,
    UserAvatarPicker
  },
  data() {
    return {
      detailState: false,
      editState: false
    }
  },

  props: {
    student: Object
  },

  methods: {
    getColor(status) {
      switch (status) {
        case 'active':
          return '#46BE8A'
        case 'reserved':
          return 'orange'
        case 'graduated':
          return 'primary'
        case 'left':
          return 'red'
        default:
          return 'grey'
      }
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 20px;
  align-items: center;
  justify-content: center;

  .main-infor {
    flex: 1;

    .student-name-wrapper {
      width: 200px;
      max-width: 100%;
    }
  }
  .detail-button {
    margin-left: auto;
    align-self: flex-end;
    display: flex;
    align-items: flex-end;
    justify-content: flex-end;
  }
}
</style>
